import useEditorBaseActions from './useEditorBaseActions'

export default useEditorBaseActions
